import React, { memo, useContext } from 'react'

import MenuItem from '@mui/material/MenuItem'

import useTrans from '@/hooks/useTrans'

import MenuLink from '@/layouts/components/MenuLink'
import { PendingTransactionsCtx } from '@/contexts/pending-transactions'

const ExtendedMenuItems = ({ handleClose }: { handleClose: () => void }) => {
  const trans = useTrans()
  const { isDisplayPendingBadge, pendingTransactions } = useContext(PendingTransactionsCtx)

  return (
    <>
      <MenuItem
        onClick={handleClose}
        disableRipple
        className="p-0 items-stretch justify-items-stretch"
      >
        <MenuLink
          className="flex items-center py-[6px] px-[16px] w-full"
          href="/history"
          data-testid="header-nav-history"
        >
          {trans.header.transactions}
          {isDisplayPendingBadge && (
            <span className="ml-[3px] inline-block h-4 min-w-[16px] bg-[#FF6701] rounded-full font-bold text-center text-xs pointer-events-none px-[3px]">
              {pendingTransactions.length}
            </span>
          )}
        </MenuLink>
      </MenuItem>
    </>
  )
}

export default memo(ExtendedMenuItems)
